<div class="db-available-theme"
     [ngClass]="{'db-available-theme_highlight': product.selected || (ongoingActivity$ | async)}"
>

  <label [dbImageZoom]="product.logo" [dbImageZoomProductType]="product.type" class="db-available-theme__logo" for="availabletheme_{{product.slug}}" [ngStyle]="{backgroundImage: 'url(' + product.logo + ')'}"></label>

  <label class="db-available-theme__main-content" for="availabletheme_{{product.slug}}">
    <div class="db-available-theme__title">
      <div [dbTooltip]="product.title">
        <a href="https://wordpress.org/themes/{{product.slug}}" target="_blank" rel="noopener" class="db-link_default db-available-theme__wp-title" *ngIf="activeTab === 'wordpress'">{{product.title}}</a>
        <a href="https://10web.io/themes/{{product.slug}}" target="_blank" rel="noopener" class="db-link_default db-available-theme__wp-title" *ngIf="activeTab === '10web'">{{product.title}}</a>
      </div>
      <db-rating-stars [rating]="product.rating"></db-rating-stars>
    </div>

    <div class="db-available-theme__description" [innerHTML]="product.description"></div>

    <div class="db-available-theme__active-installs" *ngIf="product.activeInstalls">
      <strong>{{product.activeInstalls | number:'.0' | replaceCommas}}+</strong>
      <span>{{'text_activeInstallsText' | dbText}}</span>
    </div>
  </label>

  <div class="db-available-theme__info">
    <div *ngIf="product.author" class="db-available-theme_wordpress">
      <span>{{'text_authorText' | dbText}}: </span>
      <strong>{{product.author}}</strong>
    </div>

    <div *ngIf="product.lastUpdated">
      <span>{{'text_lastUpdatedText' | dbText}}: </span>
      <strong>{{product.lastUpdated | timeFromNow}}</strong>
    </div>
    <div *ngIf="product?.requires" [innerHTML]="'text_compatibleThemes' | dbText: { compatible: product.requiredWordpressVersion}"></div>
    <div class="db-available-theme_wordpress" [innerHTML]="'text_compatibleWpThemes' | dbText"></div>

  </div>

  <div class="db-available-theme__action-progress">
    <div *ngIf="(ongoingActivity$ | async) && ((ongoingActivity$ | async).action === ActivityAction.INSTALL)">
      <div>
        <span *ngIf="(ongoingActivity$ | async).status === ActivityStatus.PENDING || (ongoingActivity$ | async).status === ActivityStatus.RUNNING">{{'text_installing' | dbText}}</span>`
        <span *ngIf="(ongoingActivity$ | async).status === ActivityStatus.DONE || ActivityStatus.FAILED">{{(ongoingActivity$ | async).message}}</span>
      </div>

      <div><db-progress-bar size="sm" [state]="ongoingActivityStatusClass$ | async" [progressPercent]="(ongoingActivity$ | async).progress"></db-progress-bar></div>
    </div>
  </div>

  <div class="db-available-theme__buttons"[ngClass]="{'db-available-theme__multiple-buttons': (product.type === ProductType.THEME && activeTab === '10web' && (product.availableForHosting && website.domain_hash) && product.installed && !product.paidVersionInstalled)}">

    <a class="db-button db-button_lg db-button_success"
       [ngClass]="{'db-button_disabled': (ongoingActivity$ | async) || !isManagable || product.paidVersionInstalled}"
       (click)="install()"
       *ngIf="product.type === ProductType.THEME && product.availableForHosting && website.domain_hash && activeTab === '10web'"
    >
      <span>{{(product.paidVersionInstalled ? 'text_premiumInstalled' : 'text_installPremium') | dbText}}</span>
    </a>

    <a class="db-button db-button_info db-button_lg sl-install-10web"
       [ngClass]="{'db-button_disabled': product.installed || (ongoingActivity$ | async) || !isManagable, 'db-button_premium': (product.paidVersionAvailable && !product.installed) || product.paidVersionInstalled}"
       (click)="install()"
       *ngIf="product.type === ProductType.THEME && activeTab === '10web' && (product.availableForHosting && website.domain_hash) && product.installed && !product.paidVersionInstalled"
    >
      <span>{{ 'text_installed' | dbText}}</span>
    </a>

    <a class="db-button db-button_lg db-button_success sl-update-10web"
       [ngClass]="{'db-button_disabled': product.paidVersionInstalled || (ongoingActivity$ | async) || !isManagable}"
       (click)="showPremiumPluginDialog()"
       *ngIf="product.type === ProductType.THEME && !product.paidVersionInstalled && !product.paidVersionAvailable && activeTab === '10web' && !(product.availableForHosting && website.domain_hash)"
    >
      <span>{{'text_getPremium' | dbText}}</span>
    </a>
    <a class="db-button db-button_info db-button_lg sl-install-10web"
       [ngClass]="{'db-button_disabled': product.installed || (ongoingActivity$ | async) || !isManagable}"
       (click)="install()"
       *ngIf="product.type === ProductType.THEME && activeTab === '10web' && !(product.availableForHosting && website.domain_hash)"
    >
      <span>{{(product.installed ? 'text_installed' : !product.paidVersionAvailable ? 'text_installFree' : 'text_install') | dbText}}</span>
    </a>
    <a class="db-button db-button_info db-button_lg sl-install-wordpress"
       [ngClass]="{'db-button_disabled': (isWpProductInstalled$ | async) || (ongoingActivity$ | async) || !isManagable}"
       (click)="install()"
       *ngIf="product.type === ProductType.THEME && activeTab === 'wordpress'"
    >
      <span>{{((isWpProductInstalled$ | async) ? 'text_installed' : 'text_install') | dbText}}</span>
    </a>
  </div>
</div>

